export default __webpack_public_path__ + "static/media/business-banner.62d24ede.png";